import { useTranslation } from 'react-i18next'
import React from 'react'
import Modal from '../../../../../../components/structure/Modal'
import { Col, Grid } from '../../../../../../packages/kiti/components/structure/Grid'
import FormItem from '../../../../../../packages/kiti/components/form/form/FormItem'
import ChecklistSelect from '../../../../../../containers/checklists/select/ChecklistSelect'
import SubmitBar from '../../../../../../packages/kiti/components/form/SubmitBar'
import { useFormState } from '../../../../../../packages/kiti/components/form/form/FormHandler'
import { useComplementaryOptionsGenerator } from '../../../_helpers/complementaryOptions'
import TextArea from '../../../../../../packages/kiti/components/form/Textarea'
import EditableSentence from '../../EditableSentence'
import Line from '../../../../../../packages/kiti/components/helpers/Line'
import { Title } from '../../../../../../packages/kiti/components/presentation/Text'
import { COLORS } from '@btime/constants'
import Separator from '../../../../../../packages/kiti/components/helpers/Separator'

const LockPlace = () => {
  const { t } = useTranslation('triggers')
  const [open, setOpen] = React.useState()
  const { form } = useFormState()
  const getComplementaryOptions = useComplementaryOptionsGenerator()
  return (
    <>
      <EditableSentence
        label={form.payload?.checklist?.name || '_______'}
        truncate={40}
        onClick={() => setOpen(true)}
        field="payload"
      />

      <Modal open={open} onClose={() => setOpen(false)} width="38rem">
        <Title size="h4" strong color={COLORS.dark2}>
          {t('lockPlace.disablePlaceForNonCompliance')}
        </Title>
        <Line />
        <Separator weight={4} />
        <Grid paddingGutter={0.5} wrap>
          <Col width="100%">
            <FormItem
              label={t('triggers:fields.checklist')}
              path={['payload', 'checklist']}
              Input={ChecklistSelect}
              mergedOptions={getComplementaryOptions('checklist')}
            />
          </Col>

          <Col width="100%">
            <FormItem label={t('lockPlace.reasonRequired')} path={['payload', 'reason']} Input={TextArea} />
          </Col>
        </Grid>

        <SubmitBar onClick={() => setOpen(false)} />
      </Modal>
    </>
  )
}

export default LockPlace
